import { FileType } from '~/core/enums'

export const DEFAULT_MIN_IMAGE_HEIGHT = 300

export const DEFAULT_MIN_IMAGE_WIDTH = 300

export const IPHONE_IMAGE_TYPE_LIST = [FileType.Heic, FileType.Heif]

export const WEB_ALLOWED_IMAGE_TYPE_LIST = [FileType.Jpeg, FileType.Png, FileType.Jpg]
